export default __webpack_public_path__ + "static/media/ellie2.39aa397d.png";